/**
 * The line-art paddle-and-ball mark used as the brand icon when a club has
 * not uploaded a logo.
 * @param {object} props
 * @param {number} props.size - px
 * @param {string} props.color - stroke / fill colour
 * @param {boolean} [props.filled] - solid paddle face (light "Pick Your Court" header) instead of outline
 * @returns {JSX.Element}
 */
function PaddleLogoIcon({ size, color, filled = false }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <g transform="rotate(-38 32 32)">
        <rect
          x="17" y="5" width="30" height="34" rx="14"
          fill={filled ? color : 'none'} stroke={color} strokeWidth="3.4"
        />
        <rect x="28" y="38" width="8" height="17" rx="3" fill={color} />
        {[[26, 16], [38, 16], [32, 23], [26, 30], [38, 30]].map(([cx, cy]) => (
          <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="2.3" fill={filled ? '#ffffff' : color} />
        ))}
      </g>
      <circle cx="49" cy="49" r="7" fill="none" stroke={color} strokeWidth="3" />
    </svg>
  );
}

export default PaddleLogoIcon;
